// src/utils/bookingReferenceUtils.ts
var SAFE_CHARS = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";
var REFERENCE_LENGTH = 6;
var REFERENCE_PREFIX = "LEAL";
function generateBookingReference() {
  let suffix = "";
  for (let i = 0; i < REFERENCE_LENGTH; i++) {
    const randomIndex = Math.floor(Math.random() * SAFE_CHARS.length);
    suffix += SAFE_CHARS[randomIndex];
  }
  return `${REFERENCE_PREFIX}-${suffix}`;
}
function isValidBookingReferenceFormat(reference) {
  if (!reference) return false;
  const normalized = reference.toUpperCase().trim();
  const pattern = new RegExp(
    `^${REFERENCE_PREFIX}-[A-Z0-9]{${REFERENCE_LENGTH}}$`
  );
  return pattern.test(normalized);
}
function normalizeBookingReference(reference) {
  if (!reference) return null;
  const normalized = reference.toUpperCase().trim();
  if (isValidBookingReferenceFormat(normalized)) {
    return normalized;
  }
  return null;
}
function extractReferenceSuffix(reference) {
  const normalized = normalizeBookingReference(reference);
  if (!normalized) return null;
  return normalized.split("-")[1];
}
function formatBookingReference(reference) {
  const normalized = normalizeBookingReference(reference);
  return normalized || reference;
}
function generateMultipleReferences(count) {
  const references = /* @__PURE__ */ new Set();
  while (references.size < count) {
    references.add(generateBookingReference());
  }
  return Array.from(references);
}
var BOOKING_REFERENCE = {
  PREFIX: REFERENCE_PREFIX,
  LENGTH: REFERENCE_LENGTH,
  SAFE_CHARS,
  PATTERN: `${REFERENCE_PREFIX}-[${SAFE_CHARS}]{${REFERENCE_LENGTH}}`,
  EXAMPLE: "LEAL-ABC123"
};

export {
  generateBookingReference,
  isValidBookingReferenceFormat,
  normalizeBookingReference,
  extractReferenceSuffix,
  formatBookingReference,
  generateMultipleReferences,
  BOOKING_REFERENCE
};
